import React from "react";
import SportRouteStar from "./SportRouteStar";
export default function SportRouteRating(props){
    return (
        <>
            <div className={"c-sportroute__rating__title"}>{props.title}</div>
            <SportRouteStar filled={true}/>
            <div className={"c-sportroute__rating__score"}>{props.score}</div>
            <div className={"c-sportroute__rating__count"}>({props.count})</div>
        </>
    )

}
